import {twJoin} from 'tailwind-merge'

import type {PropsWithChildren} from 'react'

export const DocumentContainer = ({children}: PropsWithChildren) => (
  <div className={'w-full @container/document'}>
    <div
      className={twJoin(
        'lg:grid lg:grid-cols-[1152px_224px]',
        'mx-auto w-full max-w-section gap-x-spacing-80 lg:max-w-max',
      )}
    >
      {children}
    </div>
  </div>
)
